import SettingMenu from './SettingMenu';
import CreateAccount from './CreateAccount';
import AccountAll from './AccountAll';
import AccountConfirm from './AccountConfirm';
// import FirebaseLogin from './login/FirebaseLogin';
// import ForgotPassword from './ForgotPassword';
// import FirebaseRegister from '../sessions/register/FirebaseRegister';

const settingRoutes = [
  {
    //設定メニュー
    path: '/setting/account',
    component: SettingMenu,
  },
  {
    //アカウント発行
    path: '/setting/createAccount',
    component: CreateAccount,
  },
  {
    //アカウント 発行先一覧
    path: '/setting/account-all',
    component: AccountAll,
  },
  {
    //アカウント確認
    path: '/setting/account-confirm',
    component: AccountConfirm,
  },

];

const SettingRoutes = [
  ...settingRoutes,
];


export default SettingRoutes;
